<template>
  <div>
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <p class="text-c f-s-8 agTitle">课前须知</p>
          <van-row class="f-s-8 agInfo">
            <p>
              开始学习前,请认真阅读《{{
                agreementName
              }}》内容,明确课程服务协议条款
            </p>
            <p class="m-t-11">
              点击”同意“,即表示您已阅读并同意<span
                style="color: #1062c7"
                @click="goAgreementDetial"
                >《{{ agreementName }}》</span
              >并接受协议全部条款
            </p>
          </van-row>
          <van-row class="text-c f-s-8">
            <van-col span="12" class="agFoot" @click="back">退出</van-col>
            <van-col span="12" class="agFoot" @click="agree">同意</van-col>
          </van-row>
        </div>
      </div>
    </van-overlay>
    <AgreementInfo
      ref="agreementInfo"
      :agreementName="agreementName"
      :cid="cid"
    />
  </div>
</template>

<script>
import AgreementInfo from "@/components/common/agreement/agreementInfo";
export default {
  components: {
    AgreementInfo,
  },
  data() {
    return {
      show: false,
      agreementName: "",
      agreementId: "",
    };
  },
  props: {
    cid: {
      type: String,
    },
  },
  methods: {
    back() {
      this.show = false;
    },
    agree() {
      let data = {
        uid: this.uid(),
        cid: this.cid,
      };
      this.ApiNew.Mine.updSignAgreementState(data).then((res) => {
        if (res.data.signstate == 1 || res.data.signstate == 2) {
          res.data.signInfoList.forEach((item) => {
            item.info = "";
          });
          this.$refs.agreementInfo.signInfoList = res.data.signInfoList;
          this.show = false;
          this.$refs.agreementInfo.show = true;
        }
      });
    },
    // 去查看协议详情
    goAgreementDetial() {
      this.$router.push({
        path: "/agreementDetial",
        query: {
          uid : this.uid(),
          id: this.agreementId,
        },
      });
    },
  },
};
</script>

<style scoped>
.van-overlay {
  z-index: 9999999;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  border-radius: 5px;
  width: 276px;
  /* height: 120px; */
  background-color: #fff;
}
.agTitle {
  padding-top: 18px;
  padding-bottom: 19px;
  background: #f4f7fa;
  border-radius: 5px;
}
.agInfo {
  padding-left: 26px;
  padding-right: 21px;
  padding-top: 21px;
  padding-bottom: 27px;
}
.agFoot {
  padding-top: 5px;
  padding-bottom: 5px;
  border: 1px solid #e3dede;
}
</style>